<template>
    <b-card header-tag="header" >
        <template #header v-if="title !== undefined" >
            {{title}}
        </template>
        <form class="form">
            <b-alert
                :show="dismissCountDown"
                dismissible
                :variant="alertType"
                @dismissed="closeAlert()"
                @dismiss-count-down="countDownChanged"
                fade
            >
                <p>{{alertMessage}}</p>
                <b-progress
                    :variant="alertType"
                    :max="dismissSecs"
                    :value="dismissCountDown"
                    height="4px"
                ></b-progress>
            </b-alert>

            <slot></slot>

            <div class="mt-3 d-flex" >
                <div class="pr-2">
                    <b-button 
                        variant="outline-dark" 
                        @click.prevent="$emit('create')"
                    >
                        Cadastrar
                    </b-button>
                </div>

                <div class="pl-2">
                    <b-button 
                        variant="outline-danger" 
                        @click.prevent="$emit('clear')"
                    >
                        Limpar
                    </b-button>
                </div>
            </div>
        </form>
    </b-card>
</template>
<script>
export default {
    name: 'jt-form',
    data(){
        return {
            dismissSecs: 10,
            dismissCountDown: 0,
        }
    },
    props: {
        title: {
            required: false,
            type: String
        },
        alertType : {
            required: true,
            type: String
        },
        alertShow :{
            required: true,
            type: Boolean
        },
        alertMessage: {
            required: true,
            type: String
        }
    },
    methods: {

        closeAlert: function(){
            this.dismissCountDown = 0
            this.$emit('closeAlert')
        },

        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
    },

    watch: {
        alertShow: function(newVal){
            if(newVal){
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
}
</script>